export const isSuccess = action => `${action} Success`;

export const isFailure = action => `${action} Failure`;

export const isASuccess = action => action.type.endsWith("Success");

export const isAFailure = action => action.type.endsWith("Failure");
